import { useState, useEffect, useContext } from "react";
import { AutherContext, ToastContext } from "../Context";
import { setState } from "../../Constant/LocalStorage";
import {
  userAuth,
  getToken,
  addUserToUserGroup,
  newHiverLoginInit,
  getLoggedInUserDetails
} from "../../Service/LoginServices";
import { open_popup, onOAuthSuccess } from "../../Pages/Onboarding/LoginPage/utils";
import { getAppConfig } from "../../Bifrost/api";
import { initConnectorsBifrost } from "../../Bifrost";
import { buildSettings } from "../../Constant/Settings";
import { NewAutherProvider } from "./NewAutherProvider";

export default function AutherProvider(props){

  const isNewAuther = buildSettings.NEW_AUTHER;

  if( isNewAuther )return <NewAutherProvider { ...props } />

  return <CurrentAutherProvider { ...props } />
};

function CurrentAutherProvider(props) {
  const { setNoNet, setShowToast } = useContext(ToastContext);
  const [showError, setShowError] = useState(false);
  const [authers, setAuthers] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [email, setEmail] = useState('');
  const [refetchToken, setRefetchToken] = useState(false);
  const [authToken, setAuthToken] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [userSession, setUserSession] = useState(false);
  const [redirectToken, setRedirectToken] = useState(true);
  const [redirectPage, setRedirectPage] = useState(false);
  const [userDetails, setUserDetails] = useState(false);

  const getGoogleAuthUrl = () => {
    //This is called once to get the redirect url as soon as user clicks login
    if (email) {
      return new Promise((resolve, reject) => {
        newHiverLoginInit({ email, json_mode: 1, _csrf_token: undefined }).then((res) => {
          if (res.status === 200) {
            const { redirect_url } = res?.data;
            resolve(redirect_url);
          }
          else throw 'Login init failed';
        }).catch(err => {
          console.error(err);
          reject('');
        });
      })
    }
    return new Promise((_res,rej) => console.error('No Email Present') && rej(''));
  }

  const getTokenFunction = () => {
    getToken()
      .then((res) => {
        setNoNet(false);
        setAuthToken(res.data.token);
        if (redirectPage && res.data.token == null) {
          localStorage.clear();
          getGoogleAuthUrl().then((gAuth) => {
            gAuth && open_popup(gAuth, onOAuthSuccess, email, setRefetchToken, setRedirectPage, setEmail, setAuthToken, setShowError, getTokenFunction);
          }).catch(e => console.error('Error while getting google auth: ', e));
          return;
        }
        setRedirectToken(true);
        setShowLoader(false);
      })
      .catch((rej) => {
        if (rej.message === "Network Error") {
          setNoNet(true);
          setTimeout(()=>setShowLoader(false),1000)
        } else {
          setShowToast(rej?.data?.message);
          setNoNet(false);
          setRedirectToken(false);
          setShowLoader(false);
          setAuthToken(false);
          if (rej?.response?.status === 401) {
            if(redirectPage){
              localStorage.clear();
              getGoogleAuthUrl().then((gAuth) => {
                gAuth && open_popup(gAuth, onOAuthSuccess, email, setRefetchToken, setRedirectPage, setEmail, setShowError, getTokenFunction);
              }).catch(e => console.error('Error while getting google auth: ', e));
            }
            setRedirectToken(false);
          }
        }
      });
  };

  useEffect(() => {
    getTokenFunction();
  }, [refetchToken]);

  useEffect(() => {
    const timer = setInterval(() => getTokenFunction(), 6 * 60 * 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (authToken && !admin) {
      addUserToUserGroup()
        .then(() => {
          setNoNet(false);
          userAuth()
            .then((res) => {
              let user = res?.data?.data?.user;
              setAdmin(user);
              setNoNet(false);
              setRedirectToken(true);
            })
            .catch((rej) => {
              if (rej.message === "Network Error") {
                setNoNet(true);
              } else {
                setShowToast(rej?.data?.message);
                setRedirectToken(false);
                setNoNet(false);
              }
            });
        })
        .catch((rej) => {
          if (rej.message === "Network Error") {
            setNoNet(true);
          } else {
            setShowToast(rej?.data?.message);
            setRedirectToken(false);
            setAdmin(false);
            setNoNet(false);
          }
        });
    }
    if (authToken && !userDetails) {
      getLoggedInUserDetails().then((response) => {
        const { data } = response || {};
        if (data) {
          setUserDetails(data);
          const { user_id, usergroup_id } = data;
          const { appEnv, tier } = getAppConfig();
          initConnectorsBifrost( { 
            appEnv,
            tier,
            userId: user_id,
            userGroupId: usergroup_id,
          })
          window.aptrinsic(
            "identify",
            {
              id: user_id,
            },
            {
              usergroupid: usergroup_id,
            }
          );
        }
      });
    }
  }, [authToken, userDetails]);

  useEffect(() => {
    if (admin) setState("adminDetails", admin);
  }, [admin]);

  useEffect(() => {
    setState("authToken", authToken);
  }, [authToken]);

  return (
    <AutherContext.Provider
      value={{
        autherList: authers,
        updateAuthersList: setAuthers,
        admin: admin,
        setAdmin: setAdmin,
        setEmail: setEmail,
        email: email,
        authToken: authToken,
        setAuthToken: setAuthToken,
        redirectToken: redirectToken,
        setShowError,
        showError,
        setRedirectToken: setRedirectToken,
        userSession,
        setUserSession,
        refetchToken,
        setRefetchToken,
        setShowLoader,
        setRedirectPage,
        showLoader,
        userDetails
      }}
    >
      {props.children}
    </AutherContext.Provider>
  );
}
